import { useModal } from "../../../Components/Modal";
import { useState, useEffect } from "react";
import CrudPage from "../../../Components/CrudPage";
import Text from "../../../Components/Text";
import { InventoryForm } from "./InventoryForm";
import { getAllProducts } from "../../../Model/Products";

export const Inventory = () => {
    const { ModalView, openModal, closeModal } = useModal()
    const [products, setProducts] = useState([])

    useEffect(() => {
        fetchProducts()
    }, [])

    const fetchProducts = async () => {
        const data = await getAllProducts()
        setProducts(data.filter(p => p.stockManaged))
    }

    const handleEditClick = (e, product) => {
        openModal(
            <InventoryForm selectedProduct={product} afterAction={() => {
                fetchProducts()
                closeModal()
            }
            } />
        )
    }

    const mainView = () => (
        <div className="w-full h-full flex p-3">
            <CrudPage
                title="Inventur Produkte"
                items={products}
                displayMethod={(product) => (
                    <>
                        <Text type="itemmain">{product.name}</Text>
                        <Text type="itemtext">{`Im Inventar: ${product.availableStock !== null ? product.availableStock : "Nicht definiert"}`}</Text>
                    </>
                )}
                crudActions={[
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" }]}
            />
        </div>

    )

    return (
        <div className="w-full h-full flex bg-gray-100">
            {mainView()}
            <ModalView classNames="w-auto" />
        </div>
    );
}